<template>
  <div class="content">
    <div class="md-layout">
      <nav-tabs-card>
        <template slot="content">
          <!-- START TOTAL PEMASUKAN -->

          <v-row dense>
            <v-col cols="12" sm="6" md="8" lg="10">              
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                v-model="selectedFilter"
                :items="listFilter"
                item-value="value"
                item-text="text"
                @change="filterData()"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#4CAF50" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Potensi Pemasukan"
                  style="padding-left: 10px; padding-right: 10px;font-size: 0.75rem;"
                >
                  <span>
                    Rp. {{convertCurrency(potensiPemasukan)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Potensi Pemasukan</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#43A047" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Partial"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanPartial)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Partial</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#388E3C" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanUnpaid)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Unpaid</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#2E7D32" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Paid"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanPaid)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Paid</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#2E7D32" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Complete"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanCompleted)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Complete</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#2E7D32" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanCanceled)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Cancel</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#2E7D32" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pemasukan Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pemasukanRefund)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Refund</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#2E7D32" dark style="text-align: right;">
                <v-card-title
                  class="headline small-headline justify-end"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Total Pemasukan"
                >
                  <span>
                    Rp. {{convertCurrency(totalPemasukan)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Total Pemasukan</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <!-- END TOTAL PEMASUKAN -->

          <!-- START TOTAL PENGELUARAN -->
          <v-row dense>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#F44336" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Potensi Pengeluaran"
                >
                  <span>
                    Rp. {{convertCurrency(potensiPengeluaran)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Potensi Pengeluaran</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#E53935" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Partial"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranPartial)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Partial</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#D32F2F" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranUnpaid)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Unpaid</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#C62828" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Paid"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranPaid)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Paid</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#C62828" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Complete"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranCompleted)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Complete</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#C62828" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranCanceled)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Cancel</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-card color="#C62828" dark>
                <v-card-title
                  class="headline small-headline"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Pengeluaran Unpaid"
                >
                  <span>
                    Rp. {{convertCurrency(pengeluaranRefund)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Refund</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#C62828" dark style="text-align: right;">
                <v-card-title
                  class="headline small-headline justify-end"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Total Pengeluaran"
                >
                  <span>
                    Rp. {{convertCurrency(totalPengeluaran)}}
                  </span>
                </v-card-title>
                <v-card-subtitle>Total Pengeluaran</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <!-- END TOTAL PENGELUARAN -->

          <!-- START HASIL TOTAL PEMASUKAN - TOTAL PENGELUARAN -->
          <v-row dense>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#f39c12" dark>
                <v-card-title class="headline small-headline">
                  <span class="currency-row-3">Rp. {{convertCurrency(potensiSaldo)}}</span>
                </v-card-title>
                <v-card-subtitle>Potensi Saldo</v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card color="#16a085" dark>
                <v-card-title class="headline justify-center">
                  <h3 style="margin: 0; text-align: center;">Selamat Datang {{name}}</h3>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-card color="#2980b9" dark style="text-align: right;">
                <v-card-title class="headline small-headline justify-end">
                  <span class="currency-row-3">Rp. {{convertCurrency(saldo)}}</span>
                </v-card-title>
                <v-card-subtitle>Saldo</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <!-- END HASIL TOTAL PEMASUKAN - TOTAL PENGELUARAN -->
          <!-- <v-row class="mt-5">
            <v-col>
              <h3>Selamat Datang {{name}}</h3>
            </v-col>
          </v-row> -->

          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <v-card
                class="mt-4 mx-auto"
              > 
                <v-card-text class="pb-0">
                  <div class="title font-weight-light">Trending Transaksi</div>
                </v-card-text>
                <line-chart class="pa-3" :chart-data="datacollectionJumPendapatan" :options="{responsive: true,maintainAspectRatio: false}"></line-chart>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="4" sm="4" md="6">
              <v-card
                class="mt-4 mx-auto"
              > 
                <v-card-text class="pb-0">
                  <div class="title font-weight-light">Statistik Pemasukan</div>
                </v-card-text>
                <pie-chart class="pb-3" :chart-data="datacollectionPemasukan" :options="{responsive: true,maintainAspectRatio: false}"></pie-chart>
              </v-card>
            </v-col>
            <v-col cols="4" sm="4" md="6">
              <v-card
                class="mt-4 mx-auto"
              > 
                <v-card-text class="pb-0">
                  <div class="title font-weight-light">Statistik Pengeluaran</div>
                </v-card-text>
                <pie-chart class="pb-3" :chart-data="datacollectionPengeluaran" :options="{responsive: true,maintainAspectRatio: false}"></pie-chart>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </nav-tabs-card>
    </div>
    <v-dialog v-model="invoiceModal" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Info Tagihan</v-card-title>
        <v-card-text>
          <p>Apakah anda setuju dengan tagihan per bulan sebesar:</p>
          <h2 class="text-center" style="color: #e74c3c;"><span style="color: #4e4e4e; font-size: 1rem !important;">Rp.</span> {{convertCurrency(invoiceAmount)}}</h2>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="approveInvoice"><v-icon class="ma-1">mdi-checkbox-marked-circle</v-icon>Setuju</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { NavTabsCard, LineChart, BarChart, PieChart } from "@/components";
import { formatCurrency } from "@/libs/number";
import moment from "moment";

export default {
  components: {
    NavTabsCard,
    LineChart,
    BarChart,
    PieChart
  },
  data() {
    return {
      datacollectionPemasukan: null,
      datacollectionPengeluaran: null,
      datacollectionJumPendapatan: null,
      datacollectionLabel: [],
      datacollectionPieLabel: [],
      dataPengeluaran: [],
      dataPendapatan: [],
      dataSubmissionPemasukan: [],
      dataSubmissionPengeluaran: [],
      name: "",
      potensiPemasukan: "Loading...",
      pemasukanPartial: "Loading...",
      pemasukanUnpaid: "Loading...",
      pemasukanPaid: "Loading...",
      pemasukanCompleted: "Loading",
      pemasukanCanceled: "Loading",
      pemasukanRefund: "Loading",
      totalPemasukan: "Loading",

      potensiPengeluaran: "Loading...",
      pengeluaranPartial: "Loading...",
      pengeluaranUnpaid: "Loading...",
      pengeluaranPaid: "Loading...",
      pengeluaranCompleted: "Loading",
      pengeluaranCanceled: "Loading",
      pengeluaranRefund: "Loading",
      totalPengeluaran: "Loading",

      potensiSaldo: "Loading...",
      saldo: "Loading...",

      // Invoice Modal
      invoiceModal: false,
      invoiceAmount: 0,

      //Dropdown Dashboard
      listFilter: [],
      selectedFilter: null
    };
  },
  computed: {
    ...mapState({
      invoiceData: state => state.dashboard.invoiceData
    }),
    ...mapGetters({
      
    })
  },
  methods: {
    ...mapActions({
      getUser: "auth/getUserData",
      getFirstInvoice: "dashboard/getFirstInvoice",
      approveFirstInvoice: "dashboard/approveFirstInvoice",
      getSubmissionRecap: "dashboard/getSubmissionRecap"
    }),
    async filterData() {
      const submission = await this.getSubmissionRecap(this.selectedFilter);
      const getFirstInvoice = await this.invoiceData;
      
      if(getFirstInvoice) {
        if(getFirstInvoice.is_approved == 0)
        this.invoiceModal = true;
        this.invoiceAmount = getFirstInvoice.amount;
      }
      // Pemasukan
      this.potensiPemasukan = submission.potensi_pemasukan;
      this.pemasukanPartial = submission.pemasukan_partial;
      this.pemasukanUnpaid = submission.pemasukan_unpaid;
      this.pemasukanPaid = submission.pemasukan_paid;
      this.pemasukanUnpaid = submission.pemasukan_unpaid;
      this.pemasukanCompleted = submission.pemasukan_completed;
      this.pemasukanCanceled = submission.pemasukan_canceled;
      this.pemasukanRefund = submission.pemasukan_refunded;
      this.totalPemasukan = submission.total_pemasukan;
      

      this.potensiPengeluaran = submission.potensi_pengeluaran;
      this.pengeluaranPartial = submission.pengeluaran_partial;
      this.pengeluaranUnpaid = submission.pengeluaran_unpaid;
      this.pengeluaranPaid = submission.pengeluaran_paid;
      this.pengeluaranUnpaid = submission.pengeluaran_unpaid;
      this.pengeluaranCompleted = submission.pengeluaran_completed;
      this.pengeluaranCanceled = submission.pengeluaran_canceled;
      this.pengeluaranRefund = submission.pengeluaran_refunded;
      this.totalPengeluaran = submission.total_pengeluaran;
      
      this.potensiSaldo = parseFloat(this.potensiPemasukan) - parseFloat(this.potensiPengeluaran);
      this.saldo = parseFloat(this.totalPemasukan) - parseFloat(this.totalPengeluaran);
      this.datacollectionPieLabel=Object.keys(submission.statistic.pemasukan)
      this.dataSubmissionPemasukan=Object.values(submission.statistic.pemasukan)
      this.dataSubmissionPengeluaran=Object.values(submission.statistic.pengeluaran)

      this.datacollectionPieLabel = this.datacollectionPieLabel.slice(1,7)
      this.dataSubmissionPemasukan = this.dataSubmissionPemasukan.slice(1,7)
      this.dataSubmissionPengeluaran = this.dataSubmissionPengeluaran.slice(1,7)

      this.datacollectionLabel = []
      this.dataPendapatan = []
      this.dataPengeluaran = []
      submission.trending.PEMASUKAN.forEach(item => {
        this.datacollectionLabel.push(item.date)
        this.dataPendapatan.push(Number(item.total))
      })


      submission.trending.PENGELUARAN.forEach(item => {
        this.dataPengeluaran.push(Number(item.total))
      })

      this.fillDataPemasukan()
      this.fillDataPengeluaran()
      this.fillJumData()
    },
    convertCurrency(total) {
      return formatCurrency(total);
    },
    fillJumData () {
      this.datacollectionJumPendapatan = {
        labels: this.datacollectionLabel,
        datasets: [
          {
            label: 'Pemasukan',
            borderColor: 'green',
            backgroundColor: 'transparent',
            data: this.dataPendapatan
          },
          {
            label: 'Pengeluaran',
            borderColor: 'red',
            backgroundColor: 'transparent',
            data: this.dataPengeluaran
          },
        ]
      }
    },
    fillDataPemasukan () {
      this.datacollectionPemasukan = {
        labels: this.datacollectionPieLabel,
        datasets: [
          {
            label: 'Pemasukan',
            backgroundColor: [
              "#F4A15A",
              "#F196F1",
              "#5D9EC8",
              "#B190D1",
              "#6CB35F",
              "#E36358",
            ],
            data: this.dataSubmissionPemasukan
          },
        ]
      }
    },
    fillDataPengeluaran () {
      this.datacollectionPengeluaran = {
        labels: this.datacollectionPieLabel,
        datasets: [
          {
            label: 'Pengeluaran',
            backgroundColor: [
              "#F4A15A",
              "#F196F1",
              "#5D9EC8",
              "#B190D1",
              "#6CB35F",
              "#E36358",
            ],
            data: this.dataSubmissionPengeluaran
          },
        ]
      }
    },
    async approveInvoice() {
      try{
        const response = await this.approveFirstInvoice();
        this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Tagihan berhasil disetujui!'
        });
        this.invoiceModal = false;
      }catch(e){
        console.log(e)
      }
    }
  },
  async mounted() {
    var now = new Date();
    this.selectedFilter = {
      month: now.getMonth()+1,
      year: now.getFullYear()
    }

    let j
    for (j = 3; j >= 1; j--) {
      var d = new Date();
      d.setMonth(d.getMonth() + j)
      const temp = {
        value: {
          month: d.getMonth()+1,
          year: d.getFullYear()
        },
        text: d.getMonth()+1+'/'+d.getFullYear()
      }
      this.listFilter.push(temp)
    }

    let i
    for (i = 0; i <= 11; i++) {
      var d = new Date();
      d.setMonth(d.getMonth() - i)
      const temp = {
        value: {
          month: d.getMonth()+1,
          year: d.getFullYear()
        },
        text: d.getMonth()+1+'/'+d.getFullYear()
      }
      this.listFilter.push(temp)
    }

    this.listFilter.push(
      {
        value: {
          month: null,
          year: -1
        },
        text: 'Last 12 Month'
      }
    )

    let h
    for (h = 0; h <= 3; h++) {
      var d = new Date();
      const temp = {
        value: {
          month: null,
          year: d.getFullYear()-h
        },
        text: d.getFullYear()-h
      }
      this.listFilter.push(temp)
    }

    this.listFilter.push(
      {
        value: {
          month: null,
          year: null
        },
        text: 'Lifetime'
      }
    )

    const user = await this.getUser();
    const submission = await this.getSubmissionRecap(this.selectedFilter);
    const getFirstInvoice = await this.invoiceData;
    
    if(getFirstInvoice) {
      if(getFirstInvoice.is_approved == 0)
      this.invoiceModal = true;
      this.invoiceAmount = getFirstInvoice.amount;
    }
    // Pemasukan
    this.potensiPemasukan = submission.potensi_pemasukan;
    this.pemasukanPartial = submission.pemasukan_partial;
    this.pemasukanUnpaid = submission.pemasukan_unpaid;
    this.pemasukanPaid = submission.pemasukan_paid;
    this.pemasukanUnpaid = submission.pemasukan_unpaid;
    this.pemasukanCompleted = submission.pemasukan_completed;
    this.pemasukanCanceled = submission.pemasukan_canceled;
    this.pemasukanRefund = submission.pemasukan_refunded;
    this.totalPemasukan = submission.total_pemasukan;

    this.potensiPengeluaran = submission.potensi_pengeluaran;
    this.pengeluaranPartial = submission.pengeluaran_partial;
    this.pengeluaranUnpaid = submission.pengeluaran_unpaid;
    this.pengeluaranPaid = submission.pengeluaran_paid;
    this.pengeluaranUnpaid = submission.pengeluaran_unpaid;
    this.pengeluaranCompleted = submission.pengeluaran_completed;
    this.pengeluaranCanceled = submission.pengeluaran_canceled;
    this.pengeluaranRefund = submission.pengeluaran_refunded
    this.totalPengeluaran = submission.total_pengeluaran;
    
    this.potensiSaldo = parseFloat(this.potensiPemasukan) - parseFloat(this.potensiPengeluaran);
    this.saldo = parseFloat(this.totalPemasukan) - parseFloat(this.totalPengeluaran);
    this.name = user.data.attributes.name;

    this.datacollectionPieLabel=Object.keys(submission.statistic.pemasukan)
    this.dataSubmissionPemasukan=Object.values(submission.statistic.pemasukan)
    this.dataSubmissionPengeluaran=Object.values(submission.statistic.pengeluaran)

    this.datacollectionPieLabel = this.datacollectionPieLabel.slice(1,7)
    this.dataSubmissionPemasukan = this.dataSubmissionPemasukan.slice(1,7)
    this.dataSubmissionPengeluaran = this.dataSubmissionPengeluaran.slice(1,7)

    submission.trending.PEMASUKAN.forEach(item => {
      this.datacollectionLabel.push(item.date)
      this.dataPendapatan.push(Number(item.total))
    })


    submission.trending.PENGELUARAN.forEach(item => {
      this.dataPengeluaran.push(Number(item.total))
    })

    this.fillDataPemasukan()
    this.fillDataPengeluaran()
    this.fillJumData()
    // this.fillJumDataPengeluaran()
  },
  async created() {
    const response = await this.getFirstInvoice(); 
  }
};
</script>
<style scoped>
a {
  color: #fff !important;
}
a:hover {
  color: rgba(255, 255, 255, 0.7) !important;
}
a:focus {
  color: rgba(255, 255, 255, 0.7) !important;
}
.currency-row-3 {
  margin-left: 8px;
}
.small-headline {
  padding-left: 10px !important; padding-right: 10px !important;
}
.small-headline a,span {
  font-size: 0.75rem !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.v-card__subtitle{
  font-size: 0.7rem;
  padding: 0 10px 16px 10px;
  /* padding-left: 10px !important;
  padding-right: 10px !important; */
  
}

.v-sheet--offset {
    top: -10px;
    position: relative;
  }
</style>
